export const ATTENDANCE_INSIGHTS_KEY = "attendanceActionInsightsLog";
export const LEAVE_REQUEST_ACTION = "Leave Request";

export function loadAttendanceInsights() {
  try {
    const raw = localStorage.getItem(ATTENDANCE_INSIGHTS_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveAttendanceInsights(items) {
  try {
    localStorage.setItem(ATTENDANCE_INSIGHTS_KEY, JSON.stringify(items));
  } catch {
    /* ignore */
  }
}

export function mapActionLabelToInsightAction(label) {
  const t = String(label || "").trim();
  if (t === "Leave") return LEAVE_REQUEST_ACTION;
  return t || "General";
}

export function buildLeaveRequestInsight({
  id,
  requestId,
  employee,
  employeeCode,
  employeeName,
  employeeId,
  formData = {},
  pendingAt = "Reporting Manager",
  status = "Pending",
}) {
  const code =
    employeeCode ||
    employee?.empCode ||
    employee?.emp_code ||
    employee?.employeeCode ||
    employee?.employee_code ||
    (employeeId != null ? String(employeeId) : "-");
  const name =
    employeeName ||
    employee?.user?.name ||
    employee?.name ||
    "-";

  return {
    id: id || `leave_${Date.now()}_${Math.random().toString(16).slice(2)}`,
    requestId: requestId || null,
    action: LEAVE_REQUEST_ACTION,
    employeeCode: code,
    employeeName: name,
    employeeId: employee?.id ?? employeeId ?? null,
    status,
    pendingAt,
    submittedAt: new Date().toLocaleString(),
    formData: {
      leaveType: formData.leaveType || formData.leaveStatus || "CL",
      leaveDuration: formData.leaveDuration || "full_day",
      fromDate: formData.fromDate || "",
      toDate: formData.toDate || "",
      reason: formData.reason || formData.leaveReason || "",
      notes: formData.notes || "",
    },
  };
}

export function appendLeaveRequestInsight(entry) {
  const next = [entry, ...loadAttendanceInsights()];
  saveAttendanceInsights(next);
  return next;
}

export function updateAttendanceInsight(id, patch) {
  const items = loadAttendanceInsights();
  const next = items.map((row) => (row.id === id ? { ...row, ...patch } : row));
  saveAttendanceInsights(next);
  return next;
}

export function removeAttendanceInsight(id) {
  const next = loadAttendanceInsights().filter((row) => row.id !== id);
  saveAttendanceInsights(next);
  return next;
}

export function mapQuickActionRequestToInsight(request, employeeLookup) {
  const fd = request?.formData || {};
  const employee =
    typeof employeeLookup === "function"
      ? employeeLookup(request)
      : employeeLookup || null;

  return buildLeaveRequestInsight({
    id: `leave_${request.requestId}`,
    requestId: request.requestId,
    employee,
    employeeId: request.employeeId,
    employeeName: request.userName,
    formData: fd,
    pendingAt: request.pendingWith || "Reporting Manager",
    status: request.status || "Pending",
  });
}

export function syncQuickActionLeaveRequestsToInsights(quickActionRequests, employeeResolver) {
  const existing = loadAttendanceInsights();
  const byRequestId = new Set(
    existing.map((r) => r.requestId).filter(Boolean)
  );
  const leaveRows = (quickActionRequests || []).filter(
    (r) => mapActionLabelToInsightAction(r.actionLabel) === LEAVE_REQUEST_ACTION
  );
  const toAdd = leaveRows
    .filter((r) => r.requestId && !byRequestId.has(r.requestId))
    .map((r) => mapQuickActionRequestToInsight(r, employeeResolver));
  if (!toAdd.length) return existing;
  const merged = [...toAdd, ...existing];
  saveAttendanceInsights(merged);
  return merged;
}
